module.exports = __webpack_public_path__ + "static/media/calendar_white.3f271eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar_white.svg
// module id = 897
// module chunks = 0